import moment from 'moment'

export function getDonorAgeGroup(birthDate) {
  if (!moment(birthDate).isValid()) { return 'unknown' }
  const birthYear = moment(birthDate).format('YYYY')
  const age = moment().diff(birthYear, 'y')
  if (age >= 18 && age <=24) {
    return '18-24'
  } else if (age >= 25 && age <=34) {
    return '25-34'
  } else if (age >= 35 && age <=44) {
    return '35-44'
  } else if (age >= 45 && age <=54) {
    return '45-54'
  } else if (age >= 55 && age <=64) {
    return '55-64'
  } else if (age >= 65) {
    return '65+'
  } else {
    return 'unknown'
  }
}
